import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from '../common/Logo';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => { window.scrollTo({ top: 0, behavior: 'smooth' }); setIsMenuOpen(false); };
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'py-3 border-b' : 'py-5'}`}
      style={{ background: isScrolled ? 'rgba(10,10,10,0.95)' : 'transparent', backdropFilter: isScrolled ? 'blur(12px)' : 'none', borderColor: '#1f1f1f' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex justify-between items-center">
        <button onClick={scrollToTop} className="flex items-center space-x-3 group cursor-pointer">
          <Logo className="w-8 h-8" />
          <span className="text-lg font-bold tracking-tight" style={{ color: '#f1f1f1' }}>Valtivo</span>
        </button>
        <div className="hidden md:flex items-center space-x-8">
          <button onClick={() => scrollToSection('how-it-works')} className="text-sm font-medium transition-colors" style={{ color: '#888' }}>How It Works</button>
          <button onClick={() => scrollToSection('pricing-section')} className="text-sm font-medium transition-colors" style={{ color: '#888' }}>Pricing</button>
          <button onClick={() => scrollToSection('faq-section')} className="text-sm font-medium transition-colors" style={{ color: '#888' }}>FAQ</button>
          <button onClick={() => scrollToSection('booking-section')}
            className="px-5 py-2.5 text-sm font-semibold rounded-lg transition-all"
            style={{ background: '#f1f1f1', color: '#0a0a0a' }}>
            Book a Call
          </button>
        </div>
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 rounded-lg transition-colors" style={{ color: '#f1f1f1' }}>
          <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>
      </div>
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
            className="md:hidden border-t overflow-hidden absolute w-full" style={{ background: '#0a0a0a', borderColor: '#1f1f1f' }}>
            <div className="px-6 py-6 space-y-4">
              <button onClick={() => scrollToSection('how-it-works')} className="block w-full text-left py-2 text-sm font-medium" style={{ color: '#888' }}>How It Works</button>
              <button onClick={() => scrollToSection('pricing-section')} className="block w-full text-left py-2 text-sm font-medium" style={{ color: '#888' }}>Pricing</button>
              <button onClick={() => scrollToSection('faq-section')} className="block w-full text-left py-2 text-sm font-medium" style={{ color: '#888' }}>FAQ</button>
              <button onClick={() => scrollToSection('booking-section')} className="w-full py-3 rounded-lg font-medium text-center text-sm" style={{ background: '#f1f1f1', color: '#0a0a0a' }}>
                Book a Discovery Call
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;